import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import classnames from "classnames"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import moment from "moment"
import { ConfirmAlert } from '../../../../helpers/ui/alert';

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {
            detail:[{}],
            levelComps: [
                {
                    name: "",
                    level : 1
                },
            ],
            dochead:{},
            pegawai_pelantikan:[],
            pelantik:{},
            rohaniawan:{},
            saksi:[],
            random:0 ,
            activeTab: '1',
            dataForm:{},
            docPelantikan:{},
            docPakta:{},
            docSPP:{},
            docSPMJ:{},
            docSPMT:{},
            IurlDocPelantikan:'',
            IurlDocEditPelantikan:'',
            IurlDocPakta:'',
            IurlDocEditPakta:'',
            IurlDocSPP:'',
            IurlDocEditSPP:'',
            IurlDocSPMJ:'',
            IurlDocEditSPMJ:'',
            IurlDocSPMT:'',
            IurlDocEditSPMT:'',
        }
    }
     toggle=(tab)=> {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            })
        }
    }
    generateDocPelantikan=(doctype)=> {
        this.setState({
            // dataForm: {
            //     docheaduuid : this.state.dochead.inaguration_document_uuid,
            //     doctype : doctype
            // },
            loading: true
        })
        this.detailBloc.fetchGenerateDocument({uuid: this.state.dochead.inaguration_document_uuid,type: doctype})
    }
    generateDocPelantikanPakta=(doctype)=> {
        this.setState({
            loading: true
        })
        this.detailBloc.fetchGenerateDocumentPakta({uuid: this.state.dochead.inaguration_document_uuid,type: doctype})
        // alert('aaaaaaaaaaaaaa')
    }
    generateDocPelantikanSPP=(doctype)=> {
        this.setState({
            loading: true
        })
        this.detailBloc.fetchGenerateDocumentSPP({uuid: this.state.dochead.inaguration_document_uuid,type: doctype})
        // alert('aaaaaaaaaaaaaa')
    }
    generateDocPelantikanSPMJ=(doctype)=> {
        this.setState({
            loading: true
        })
        this.detailBloc.fetchGenerateDocumentSPMJ({uuid: this.state.dochead.inaguration_document_uuid,type: doctype})
        // alert('aaaaaaaaaaaaaa')
    }
    generateDocPelantikanSPMT=(doctype)=> {
        this.setState({
            loading: true
        })
        this.detailBloc.fetchGenerateDocumentSPMT({uuid: this.state.dochead.inaguration_document_uuid,type: doctype})
        // alert('aaaaaaaaaaaaaa')
    }
    handleOnDodraftingPelantikan = () => {     
        const myWindowDoc = window.open(this.state.IurlDocEditPelantikan,"_blank",);   
        const timer = setInterval(() => { 
            if(myWindowDoc.closed) {
                clearInterval(timer);
                this.setState({
                    random : Math.floor((Math.random() * 100) + 1),
                    // loading : true
                })                
            }
        }, 1000);
        
    };
    handleOnDodraftingPakta = () => {     
        const myWindowDoc = window.open(this.state.IurlDocEditPakta,"_blank",);   
        const timer = setInterval(() => { 
            if(myWindowDoc.closed) {
                clearInterval(timer);
                this.setState({
                    random : Math.floor((Math.random() * 100) + 1),
                    // loading : true
                })                
            }
        }, 1000);
        
    };
    handleOnDodraftingSPP = () => {     
        const myWindowDoc = window.open(this.state.IurlDocEditSPP,"_blank",);   
        const timer = setInterval(() => { 
            if(myWindowDoc.closed) {
                clearInterval(timer);
                this.setState({
                    random : Math.floor((Math.random() * 100) + 1),
                    // loading : true
                })                
            }
        }, 1000);
        
    };
    handleOnDodraftingSPMJ = () => {     
        const myWindowDoc = window.open(this.state.IurlDocEditSPMJ,"_blank",);   
        const timer = setInterval(() => { 
            if(myWindowDoc.closed) {
                clearInterval(timer);
                this.setState({
                    random : Math.floor((Math.random() * 100) + 1),
                    // loading : true
                })                
            }
        }, 1000);
        
    };
    handleOnDodraftingSPMT = () => {     
        const myWindowDoc = window.open(this.state.IurlDocEditSPMT,"_blank",);   
        const timer = setInterval(() => { 
            if(myWindowDoc.closed) {
                clearInterval(timer);
                this.setState({
                    random : Math.floor((Math.random() * 100) + 1),
                    // loading : true
                })                
            }
        }, 1000);
        
    };
    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                if(this.state.confirmAction == 1){
                    window.location.href = `/kepegawaian/dokumen_pelantikan.html?update&uuid=${this.state.dochead.inaguration_document_uuid}`;
                }else{
                    this.inactiveData()
                    // alert('aaaa')
                }
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.detailBloc.fetchInactive({ uuid: this.state.dochead.inaguration_document_uuid })
    }
    
    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response.dochead.inaguration_document_type_name)
                        this.setState({
                            detail: response,
                            dochead: response.dochead,
                            pegawai_pelantikan: response.pegawai_pelantikan,
                            pelantik: response.pelantik,
                            rohaniawan: response.rohaniawan,
                            saksi: response.saksi,
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
        
            this.detailBloc.generateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status==true) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            loading: false,
                            success:true
                        })
                        this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })
                        this.detailBloc.fetchDetailDokPakta({uuid: queryParams.get('uuid'),type: 2 })
                        this.detailBloc.fetchDetailDokSPP({uuid: queryParams.get('uuid'),type: 3 })
                        this.detailBloc.fetchDetailDokSPMJ({uuid: queryParams.get('uuid'),type: 4 })
                        this.detailBloc.fetchDetailDokSPMT({uuid: queryParams.get('uuid'),type: 5 })
                        console.log(result.data.status)
                    }else{
                        this.setState({
                            loading: false,
                            failed: true
                        })
                    }
                    break
                    case apiResponse.ERROR:
                        
                        break
                        default:
                            break
                        }
                    })

            this.detailBloc.generatePaktaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status==true) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            loading: false,
                            success:true
                        })
                        this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })
                        this.detailBloc.fetchDetailDokPakta({uuid: queryParams.get('uuid'),type: 2 })
                        this.detailBloc.fetchDetailDokSPP({uuid: queryParams.get('uuid'),type: 3 })
                        this.detailBloc.fetchDetailDokSPMJ({uuid: queryParams.get('uuid'),type: 4 })
                        this.detailBloc.fetchDetailDokSPMT({uuid: queryParams.get('uuid'),type: 5 })
                        console.log(result.data.status)
                    }else{
                        this.setState({
                            loading: false,
                            failed: true
                        })
                    }
                    break
                    case apiResponse.ERROR:
                        
                        break
                        default:
                            break
                        }
                    })
            this.detailBloc.generateSPPChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status==true) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            loading: false,
                            success:true
                        })
                        this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })
                        this.detailBloc.fetchDetailDokPakta({uuid: queryParams.get('uuid'),type: 2 })
                        this.detailBloc.fetchDetailDokSPP({uuid: queryParams.get('uuid'),type: 3 })
                        this.detailBloc.fetchDetailDokSPMJ({uuid: queryParams.get('uuid'),type: 4 })
                        this.detailBloc.fetchDetailDokSPMT({uuid: queryParams.get('uuid'),type: 5 })
                        console.log(result.data.status)
                    }else{
                        this.setState({
                            loading: false,
                            failed: true
                        })
                    }
                    break
                    case apiResponse.ERROR:
                        
                        break
                        default:
                            break
                        }
                    })
            this.detailBloc.generateSPMJChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status==true) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            loading: false,
                            success:true
                        })
                        this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })
                        this.detailBloc.fetchDetailDokPakta({uuid: queryParams.get('uuid'),type: 2 })
                        this.detailBloc.fetchDetailDokSPP({uuid: queryParams.get('uuid'),type: 3 })
                        this.detailBloc.fetchDetailDokSPMJ({uuid: queryParams.get('uuid'),type: 4 })
                        this.detailBloc.fetchDetailDokSPMT({uuid: queryParams.get('uuid'),type: 5 })
                        console.log(result.data.status)
                    }else{
                        this.setState({
                            loading: false,
                            failed: true
                        })
                    }
                    break
                    case apiResponse.ERROR:
                        
                        break
                        default:
                            break
                        }
                    })
            this.detailBloc.generateSPMTChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status==true) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            loading: false,
                            success:true
                        })
                        this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })
                        this.detailBloc.fetchDetailDokPakta({uuid: queryParams.get('uuid'),type: 2 })
                        this.detailBloc.fetchDetailDokSPP({uuid: queryParams.get('uuid'),type: 3 })
                        this.detailBloc.fetchDetailDokSPMJ({uuid: queryParams.get('uuid'),type: 4 })
                        this.detailBloc.fetchDetailDokSPMT({uuid: queryParams.get('uuid'),type: 5 })
                        console.log(result.data.status)
                    }else{
                        this.setState({
                            loading: false,
                            failed: true
                        })
                    }
                    break
                    case apiResponse.ERROR:
                        
                        break
                        default:
                            break
                        }
                    })
                    
                    this.detailBloc.docPelantikanChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                if(result.data.status==true) {
                                    let response = result.data.response
                                    console.log(result.data.status)
                                    // console.log(response.document_file_path)
                                    this.setState({
                                        docPelantikan: response.detail,
                                        IurlDocPelantikan : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=embedview",
                                        IurlDocEditPelantikan : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=default",
                                    })
                                }
                                break
                            case apiResponse.ERROR:
                                
                                break
                            default:
                                break
                        }
                    })
                    this.detailBloc.fetchDetailDokpelantikan({uuid: queryParams.get('uuid'),type: 1 })

                    this.detailBloc.docPaktaChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                if(result.data.status==true) {
                                    let response = result.data.response
                                    // console.log(response.dochead.inaguration_document_type_name)
                                    this.setState({
                                        docPakta: response,
                                        IurlDocPakta : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=embedview",
                                        IurlDocEditPakta : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=default",
                                    })
                                    console.log(this.state.IurlDocPakta+' ini link pakta')
                                    console.log(this.state.docPakta)
                                }
                                break
                            case apiResponse.ERROR:
                                
                                break
                            default:
                                break
                        }
                    })
                    this.detailBloc.fetchDetailDokPakta({uuid: queryParams.get('uuid'),type: 2 })

                    this.detailBloc.docSPPChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                if(result.data.status==true) {
                                    let response = result.data.response
                                    // console.log(response.dochead.inaguration_document_type_name)
                                    this.setState({
                                        docSPP: response,
                                        IurlDocSPP : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=embedview",
                                        IurlDocEditSPP : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=default",
                                    })
                                }
                                break
                            case apiResponse.ERROR:
                                
                                break
                            default:
                                break
                        }
                    })
                    this.detailBloc.fetchDetailDokSPP({uuid: queryParams.get('uuid'),type: 3 })

                    this.detailBloc.docSPMJChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                if(result.data.status==true) {
                                    let response = result.data.response
                                    this.setState({
                                        docSPMJ: response,
                                        IurlDocSPMJ : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=embedview",
                                        IurlDocEditSPMJ : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=default",
                                    })
                                    console.log(this.state.docSPMJ)
                                    console.log('ini spmj')
                                }
                                break
                            case apiResponse.ERROR:
                                
                                break
                            default:
                                break
                        }
                    })
                    this.detailBloc.fetchDetailDokSPMJ({uuid: queryParams.get('uuid'),type: 4 })

                    this.detailBloc.docSPMTChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                if(result.data.status==true) {
                                    let response = result.data.response
                                    // console.log(response.dochead.inaguration_document_type_name)
                                    this.setState({
                                        docSPMT: response,
                                        IurlDocSPMT : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=embedview",
                                        IurlDocEditSPMT : response.document_url + "/:w:/r/_layouts/15/Doc.aspx?sourcedoc={" +  response.detail?.document_file_uuid + "}&action=default",
                                    })
                                    console.log(this.state.docSPMT)
                                    console.log('ini spmt')
                                }
                                break
                            case apiResponse.ERROR:
                                
                                break
                            default:
                                break
                        }
                    })
                    this.detailBloc.fetchDetailDokSPMT({uuid: queryParams.get('uuid'),type: 5 })

                    console.log(this.state.docPelantikan)

                    this.detailBloc.inactiveChannel.subscribe((result) => {
                        switch (result.status) {
                            case apiResponse.COMPLETED:
                                this.setState({
                                    loading: false,
                                    success: true,
                                    loadingTable: true
                                }, function () {
                                    // this.setTokenAPI()
                                    // this.props.handleInactiveSuccess()
                                    window.location.href = '/kepegawaian/dokumen_pelantikan.html';
                                });
                                break
                            case apiResponse.ERROR:
                                this.setState({
                                    loading: false,
                                    failed: true,
                                });
                                break
                            default:
                                break
                        }
                    })
    }
    reformatLevel = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["name"] = data.level_name;
          newObj["level"] = data.level_no;
      
          return newObj;
        });
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Data Dokumen Pelantikan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Detail Data Dokumen
                                    </CardSubtitle>
                                    <hr />
                                    <Row className="mb-3">
                                        <Col md="5">
                                            
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Tanggal Pelantikan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{(this.state.dochead.inaguration_document_date != null) ? moment(this.state.dochead.inaguration_document_date).format('DD/MM/YYYY') : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Lokasi
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_place !== "" ? this.state.dochead.inaguration_document_place : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Tempat Pelaksanaan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_place_room !== "" ? this.state.dochead.inaguration_document_place_room : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                        
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Pegawai
                                                </label>
                                                <Col md="9">
                                                
                                                    {
                                                        this.state.pegawai_pelantikan.map((data, index) => {
                                                            return (
                                                                <>
                                                                    {(index+1)} . {data.employee_full_name} ({data.position_name}) <br />
                                                                </>
                                                            )    
                                                        })
                                                    }
                                                    
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Pejabat Pelantik
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.pelantik ?
                                                            <>{this.state.pelantik.employee_full_name !== "" ? this.state.pelantik.employee_full_name : '-'}</>
                                                        : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <hr />
                                            <Row className="mb-3">
                                                <label className="col-md-12">
                                                    Pejabat Pendamping (Rohaniawan Islam)
                                                </label>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nama
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan !== "" ? this.state.dochead.inaguration_document_rohaniawan: '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    NIP
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_islam_nip !== "" ? this.state.dochead.inaguration_document_rohaniawan_islam_nip: '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Jabatan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_position !== "" ? this.state.dochead.inaguration_document_rohaniawan_position: '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <hr />
                                            <Row className="mb-3">
                                                <label className="col-md-12">
                                                    Pejabat Pendamping (Rohaniawan Kristen)
                                                </label>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nama
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_kristen !== "" ? this.state.dochead.inaguration_document_rohaniawan_kristen : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    NIP
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_kristen_nip !== "" ? this.state.dochead.inaguration_document_rohaniawan_kristen_nip : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Jabatan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_kristen_position !== "" ? this.state.dochead.inaguration_document_rohaniawan_kristen_position : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <hr />
                                            <Row className="mb-3">
                                                <label className="col-md-12">
                                                    Pejabat Pendamping (Rohaniawan Katolik)
                                                </label>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nama
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_katholik !== "" ? this.state.dochead.inaguration_document_rohaniawan_katholik : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    NIP
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_katholik_nip !== "" ? this.state.dochead.inaguration_document_rohaniawan_katholik_nip : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Jabatan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_katholik_position !== "" ? this.state.dochead.inaguration_document_rohaniawan_katholik_position : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <hr />
                                            <Row className="mb-3">
                                                <label className="col-md-12">
                                                    Pejabat Pendamping (Rohaniawan Hindu)
                                                </label>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nama
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_hindu !== "" ? this.state.dochead.inaguration_document_rohaniawan_hindu  : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    NIP
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_hindu_nip !== "" ? this.state.dochead.inaguration_document_rohaniawan_hindu_nip  : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Jabatan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_hindu_position !== "" ? this.state.dochead.inaguration_document_rohaniawan_hindu_position  : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <hr />
                                            <Row className="mb-3">
                                                <label className="col-md-12">
                                                    Pejabat Pendamping (Rohaniawan Buddha)
                                                </label>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nama
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_budha !== "" ? this.state.dochead.inaguration_document_rohaniawan_budha : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    NIP
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_budha_nip !== "" ? this.state.dochead.inaguration_document_rohaniawan_budha_nip  : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Jabatan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_budha_position !== "" ? this.state.dochead.inaguration_document_rohaniawan_budha_position : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <hr />
                                            <Row className="mb-3">
                                                <label className="col-md-12">
                                                    Pejabat Pendamping (Rohaniawan Konghucu)
                                                </label>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nama
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_konghucu !== "" ? this.state.dochead.inaguration_document_rohaniawan_konghucu  : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    NIP
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_konghucu_nip !== "" ? this.state.dochead.inaguration_document_rohaniawan_konghucu_nip: '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Jabatan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_rohaniawan_konghucu_position !== "" ? this.state.dochead.inaguration_document_rohaniawan_konghucu_position : '-'}</>
                                                        :
                                                            <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <hr />
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Saksi
                                                </label>
                                                <Col md="9">
                                                    
                                                    {
                                                        this.state.saksi.map((data, index) => {
                                                            return (
                                                                <>
                                                                    {(index+1)} . {data.employee_full_name} <br />     
                                                                </>
                                                            )    
                                                        })
                                                    }
                                                    
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nomor SK
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_sk_number !== "" ? this.state.dochead.inaguration_document_sk_number : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Tanggal SK
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{(this.state.dochead.inaguration_document_sk_date != null) ? moment(this.state.dochead.inaguration_document_sk_date).format('DD/MM/YYYY') : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nomor SPP
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_sppno !== "" ? this.state.dochead.inaguration_document_sppno : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nomor SPMJ
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_spmjno !== "" ? this.state.dochead.inaguration_document_spmjno : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nomor SPMT
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.dochead ?
                                                            <>{this.state.dochead.inaguration_document_spmtno !== "" ? this.state.dochead.inaguration_document_spmtno : '-'}</>
                                                        : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            
                                            <Row className="mb-3">
                                                <Col md="9">
                                                        <Button color="success"
                                                        onClick={() => {
                                                            this.setState({confirmtext:"Apakah anda yakin akan mengubah form data, dokumen pelantikan yang sudah digenerate akan terhapus?"})
                                                            this.setState({confirm:true})
                                                            this.setState({confirmAction:1})
                                                            
                                                            
                                                        }}
                                                        style={{
                                                            padding: '2px 5px'
                                                        }}> Ubah Form</Button>
                                                    
                                                </Col>
                                                <Col md="3">
                                                </Col>
                                            </Row>
                                            <hr />
                                            <Row className="mb-3">
                                                <Col md="9">
                                                    <Link to="/kepegawaian/dokumen_pelantikan.html" className="btn btn-danger waves-effect">
                                                        <i className="uil-arrow-left"></i> Kembali
                                                    </Link>
                                                    &nbsp;
                                                    <Button 
                                                        className="btn btn-warning" 
                                                        id={"delete-" + this.state.dochead.inaguration_document_id}
                                                        onClick={() => {
                                                            this.setState({confirmtext:"Apakah anda yakin akan Menghapus Data dokumen pelantikan ini?"})
                                                            this.setState({
                                                                confirm: true,
                                                                confirmAction : 2
                                                            })
                                                        }}>
                                                            Batalkan dokumen Pelantikan
                                                    </Button>
                                                </Col>
                                                <Col md="3">
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col md="9">
                                                </Col>
                                                <Col md="3">
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md="7" style={{marginTop: '-16px'}}>
                                            
                                            <Nav tabs>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                        active: this.state.activeTab === "1",
                                                    })}
                                                    onClick={() => {
                                                        this.toggle("1")
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                    <span className="d-none d-sm-block">BA Pelantikan</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                    active: this.state.activeTab === "2",
                                                        })}
                                                    onClick={() => {
                                                        this.toggle("2")
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                                    <span className="d-none d-sm-block">Pakta Integritas</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                        active: this.state.activeTab === "3",
                                                    })}
                                                    onClick={() => {
                                                        this.toggle("3")
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                    <span className="d-none d-sm-block">SPP</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                        active: this.state.activeTab === "4",
                                                    })}
                                                    onClick={() => {
                                                        this.toggle("4")
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                    <span className="d-none d-sm-block">SPMJ</span>
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                        active: this.state.activeTab === "5",
                                                    })}
                                                    onClick={() => {
                                                        this.toggle("5")
                                                    }}
                                                >
                                                    <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                    <span className="d-none d-sm-block">SPMT</span>
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <TabContent activeTab={this.state.activeTab} className="p-3 text-muted">
                                            <TabPane tabId="1">
                                                <Row className="mb-3">
                                                    <Col md="8">
                                                    </Col>
                                                    <Col md="4" className='text-right'>
                                                    {(this.state.docPelantikan)?
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.handleOnDodraftingPelantikan()
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Ubah Draft</Button>
                                                            :
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.generateDocPelantikan(1)
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Genarate BA Pelantikan</Button>
                                                    }
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {(this.state.docPelantikan)?
                                                    <iframe 
                                                        key={this.state.random}
                                                        src={this.state.IurlDocPelantikan} 
                                                        width={"100%"} 
                                                        height={"880"}
                                                        onLoad={this.hideLoad}
                                                        frameBorder="10"
                                                        marginHeight="0"
                                                        marginWidth="0"
                                                        > 
                                                    </iframe>
                                                    :""
                                                }
                                            </TabPane>
                                            <TabPane tabId="2">
                                            <Row className="mb-3">
                                                    <Col md="8">
                                                    </Col>
                                                    <Col md="4" className='text-right'>
                                                    {(this.state.docPakta.detail)?
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.handleOnDodraftingPakta()
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Ubah Draft</Button>
                                                            :
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.generateDocPelantikanPakta(2)
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Genarate Pakta Integritas</Button>
                                                    }
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {(this.state.docPakta)?
                                                    <iframe 
                                                        key={this.state.random}
                                                        src={this.state.IurlDocPakta} 
                                                        width={"100%"} 
                                                        height={"880"}
                                                        onLoad={this.hideLoad}
                                                        frameBorder="10"
                                                        marginHeight="0"
                                                        marginWidth="0"
                                                        > 
                                                    </iframe>
                                                    :""
                                                }
                                            </TabPane>
                                            <TabPane tabId="3">
                                            <Row className="mb-3">
                                                    <Col md="8">
                                                    </Col>
                                                    <Col md="4" className='text-right'>
                                                    {(this.state.docSPP.detail)?
                                                        <Button color="success"
                                                        onClick={() => {
                                                            this.handleOnDodraftingSPP()
                                                        }}
                                                        style={{
                                                            padding: '2px 5px'
                                                        }}> Ubah Draft</Button>
                                                        :
                                                        <Button color="success"
                                                        onClick={() => {
                                                            this.generateDocPelantikanSPP(3)
                                                        }}
                                                        style={{
                                                            padding: '2px 5px'
                                                        }}> Genarate Dokumen SPP</Button>
                                                        
                                                    }
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {(this.state.docSPP.detail)?
                                                    <iframe 
                                                        key={this.state.random}
                                                        src={this.state.IurlDocSPP} 
                                                        width={"100%"} 
                                                        height={"880"}
                                                        onLoad={this.hideLoad}
                                                        frameBorder="10"
                                                        marginHeight="0"
                                                        marginWidth="0"
                                                        > 
                                                    </iframe>
                                                    :""
                                                }
                                            </TabPane>
                                            <TabPane tabId="4">
                                            <Row className="mb-3">
                                                    <Col md="8">
                                                    </Col>
                                                    <Col md="4" className='text-right'>
                                                    {(this.state.docSPMJ.detail!=null)?
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.handleOnDodraftingSPMJ()
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Ubah Draft</Button>
                                                            :
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.generateDocPelantikanSPMJ(4)
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Genarate Dokumen SPMJ</Button>
                                                    }
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {(this.state.docSPMJ.detail!=null)?
                                                    <iframe 
                                                        key={this.state.random}
                                                        src={this.state.IurlDocSPMJ} 
                                                        width={"100%"} 
                                                        height={"880"}
                                                        onLoad={this.hideLoad}
                                                        frameBorder="10"
                                                        marginHeight="0"
                                                        marginWidth="0"
                                                        > 
                                                    </iframe>
                                                    :""
                                                }
                                            </TabPane>
                                            <TabPane tabId="5">
                                            <Row className="mb-3">
                                                    <Col md="8">
                                                    </Col>
                                                    <Col md="4" className='text-right'>
                                                    {(this.state.docSPMT.detail)?
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.handleOnDodraftingSPMT()
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Ubah Draft</Button>
                                                            :
                                                        <Button color="success"
                                                            onClick={() => {
                                                                this.generateDocPelantikanSPMT(5)
                                                            }}
                                                            style={{
                                                                padding: '2px 5px'
                                                            }}> Genarate Dokumen SPMT</Button>
                                                    }
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {(this.state.docSPMT)?
                                                    <iframe 
                                                        key={this.state.random}
                                                        src={this.state.IurlDocSPMT} 
                                                        width={"100%"} 
                                                        height={"880"}
                                                        onLoad={this.hideLoad}
                                                        frameBorder="10"
                                                        marginHeight="0"
                                                        marginWidth="0"
                                                        > 
                                                    </iframe>
                                                    :""
                                                }
                                            </TabPane>
                                        </TabContent>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo={this.state.confirmtext}

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Document berhasil Digenerate"

                    failedTitle="Gagal!"
                    failedInfo="Dokumen gagal Digenerate"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);